import layoutManagerSaga from './layout';

export default [
  layoutManagerSaga(),
];
